<template>
  <p
    v-if="component"
    :id="component.uid"
    :qaid="`${componentPrefix}-${component.uid}`"
    :class="['trek-paragraph-component', paragraphStyles, component.styleClasses]"
    v-html="component.content"
  />
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      componentPrefix: 'trek-paragraph-component',
    };
  },
  computed: {
    paragraphStyles() {
      return {
        'max-w-screen-xl mx-auto text-center font-body font-light text-md lg:text-lg':
          this.component?.bodyCopyStyleEnum === 'MarqueeStyle',
        'w-full': this.component?.bodyCopyStyleEnum !== 'MarqueeStyle',
      };
    },
  },
};
</script>
